module.exports = __webpack_public_path__ + "img/Im13.39f6d3ae.png";